import type {
	CreateNotificationBody,
	NotificationDto,
} from "@ied/shared-types";
import { useMutation } from "@tanstack/react-query";
import { SERVICE_API } from "@/lib/consts";

export function useSaveNotification() {
	return useMutation({
		mutationKey: ["notifications"],
		mutationFn: async (data: CreateNotificationBody) => {
			const res = await fetch(`${SERVICE_API}/api/notifications`, {
				method: "POST",
				credentials: "include",
				body: JSON.stringify({ ...data, sent_status: "Pending" }),
				headers: {
					"Content-Type": "application/json",
				},
			});
			if (!res.ok) {
				throw new Error("Unable to create notification");
			}

			return (await res.json()) as NotificationDto;
		},
	});
}
